/* Buena Vita - bundle tier selector.

   Sets the quantity input from the chosen tier. The actual discount is a
   Shopify automatic BXGY discount applied at checkout - this file only moves
   the quantity, it never touches price. If the discount is removed in admin,
   these tiers will still set the quantity but the customer will be charged
   full price, which is exactly the fake-bundle failure this store already had
   once. Turn the tier off in the section settings whenever the discount goes. */
(function () {
  'use strict';

  if (window.__bvBundleInit) return;
  window.__bvBundleInit = true;

  function sync(group) {
    var radios = group.querySelectorAll('input[type="radio"][data-bv-tier]');
    var qty = null;

    for (var i = 0; i < radios.length; i++) {
      var card = radios[i].closest('.bv-tier');
      if (card) card.classList.toggle('is-selected', radios[i].checked);
      if (radios[i].checked) qty = radios[i].getAttribute('data-bv-tier');
    }

    if (!qty) return;

    // The quantity input is the single source of truth for what gets posted;
    // the tiers are just a friendlier way of setting it.
    var form = group.closest('form') || document.querySelector('form.bv-buy__form');
    var input = form ? form.querySelector('[data-bv-qty-input]') : null;
    if (!input) return;

    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init(scope) {
    var groups = (scope || document).querySelectorAll('.bv-tiers');

    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        if (group.dataset.bvBound === '1') return;
        group.dataset.bvBound = '1';
        group.addEventListener('change', function () { sync(group); });
        sync(group);
      })(groups[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
